const getDomainName = () => {
    try {
      const { hostname } = new URL(window.location.href);
      const domainParts = hostname.replace(/^www\./, "").split(".");
      const name = domainParts[0];
  
      return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
        
    } catch (error) {
      console.error("Error parsing domain name:", error);
      return "";
    }
  };
  
export default getDomainName;  